export var EmailRecipientFilterType;
(function (EmailRecipientFilterType) {
    EmailRecipientFilterType["RegistrationMembers"] = "RegistrationMembers";
    EmailRecipientFilterType["RegistrationParents"] = "RegistrationParents";
    EmailRecipientFilterType["RegistrationUnverified"] = "RegistrationUnverified";
    EmailRecipientFilterType["Members"] = "Members";
    EmailRecipientFilterType["MemberParents"] = "MemberParents";
    EmailRecipientFilterType["MemberUnverified"] = "MemberUnverified";
    EmailRecipientFilterType["Orders"] = "Orders";
    EmailRecipientFilterType["ReceivableBalances"] = "ReceivableBalances";
    EmailRecipientFilterType["Documents"] = "Documents";
    EmailRecipientFilterType["Organizations"] = "Organizations";
    EmailRecipientFilterType["WebshopDiscountCodes"] = "WebshopDiscountCodes";
    // These naming should have been in plural:
    // Please don't add new enum values not in plural.
    EmailRecipientFilterType["Payment"] = "Payment";
    EmailRecipientFilterType["PaymentOrganization"] = "PaymentOrganization";
})(EmailRecipientFilterType || (EmailRecipientFilterType = {}));
//# sourceMappingURL=EmailRecipientFilterType.js.map